var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import styled from '@emotion/styled';
import { Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { AudioPlayer, MuiBox, MuiStack } from '../..';
import { MuiImagePopUp } from '../../atoms/imageDialogBox';
import SkeletonLoader from '../../atoms/sketeton';
import ViewAllImagePopUp from '../../atoms/viewAllImagePopUp';
import { systemColor } from '../../../theme/systemColor';
var Box = styled(MuiBox)(function (_ref) {
    var theme = _ref.theme;
    return {
        padding: 2,
        borderRadius: "12px",
        backgroundColor: "#F4F7FA"
    };
});
export default function ViewJobsDetails(props) {
    var _a = useState(props.listItems), jobItemList = _a[0], setJobItemList = _a[1];
    var _b = useState(false), isDrawerOpen = _b[0], setISDrawerOpen = _b[1];
    var _c = useState(""), imageURL = _c[0], setImageURL = _c[1];
    useEffect(function () {
        setJobItemList(props.listItems);
    }, [props.listItems]);
    var handleViewAllClick = function (items) {
        var _jobItem = __spreadArray([], jobItemList, true);
        var showAllImages = _jobItem.map(function (item) { return item._id === items._id ? _objectSpread(_objectSpread({}, item), {}, {
            isShowImage: !item.isShowImage
        }) : item; });
        setJobItemList(showAllImages);
    };
    // const handleClose = (photoIndex: number) => {
    //     setISDrawerOpen(null);
    // }
    // const handleClickImage = (photoIndex: number) => {
    //     setISDrawerOpen(photoIndex)
    // }
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var handleClose = function () {
        setImageURL("");
        setISDrawerOpen(false);
    };
    return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(FormControl, {
        sx: {
            width: '100%',
            margin: "0px"
        },
        component: "fieldset",
        variant: "standard"
    }, /*#__PURE__*/ React.createElement(FormGroup, {
        sx: {
            padding: '12px',
            margin: 0,
            paddingTop: 0
        }
    }, (jobItemList === null || jobItemList === void 0 ? void 0 : jobItemList.length) > 0 ? jobItemList === null || jobItemList === void 0 ? void 0 : jobItemList.map(function (item, index) {
        var _props$searchedItems, _item$images;
        var existInSearch = (_props$searchedItems = props.searchedItems) === null || _props$searchedItems === void 0 ? void 0 : _props$searchedItems.find(function (searchItem) { return searchItem.ComplaintId === item.ComplaintId; });
        if (!existInSearch && props.searchValue.length >= 3) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
        return /*#__PURE__*/ React.createElement(Grid, {
            padding: 0,
            key: index + 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            padding: 0,
            margin: 0,
            spacing: 1.3
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            disabled: true,
            key: "mode-checkbox-".concat(index),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                id: "jobItemCheckBox",
                checked: item.isCheckBoxClicked || false
                //onChange={(e) => handleChange(e, item)}
            }),
            label: "",
            sx: {
                marginLeft: 0,
                marginRight: 0,
                minHeight: '50px',
                '& .MuiButtonBase-root': {
                    padding: 0
                }
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            id: "jobItemName",
            sx: {
                fontSize: 'base',
                fontWeight: 'medium',
                color: 'text.primary'
            },
            alignSelf: "center"
        }, item === null || item === void 0 ? void 0 : item.ComplaintName)), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            id: "jobItemComment",
            sx: {
                wordBreak: "break-all",
                ize: 'base',
                fontWeight: 'medium',
                color: 'text.primary'
            }
        }, item === null || item === void 0 ? void 0 : item.Comments)), (item === null || item === void 0 ? void 0 : item.images) && /*#__PURE__*/ React.createElement(MuiStack, {
            paddingY: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'row',
            justifyContent: 'left',
            sx: {
                display: 'flex',
                flexWrap: 'wrap',
                overflowY: 'auto',
                gap: '12px'
            }
        }, item === null || item === void 0 || (_item$images = item.images) === null || _item$images === void 0 ? void 0 : _item$images.map(function (image, photoIndex) { /*#__PURE__*/ return React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
            src: image.blobUrl,
            id: "downloadCustomerImg" + photoIndex,
            alt: "Image ".concat(photoIndex + 1),
            style: {
                width: '82px',
                height: '82px',
                borderRadius: '8px',
                objectFit: "cover"
            },
            onClick: function () { return handleClickImage(image.blobUrl); }
        }))); }))), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
            isOpen: item.isShowImage,
            onClosed: function () { return handleViewAllClick(item); },
            images: item === null || item === void 0 ? void 0 : item.images
        }), (item === null || item === void 0 ? void 0 : item.audioUrl) && /*#__PURE__*/ React.createElement(MuiStack, {
            paddingX: "9px",
            border: "1px solid ".concat(systemColor.grey),
            borderRadius: '8px',
            height: '52px',
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(AudioPlayer, {
            src: item === null || item === void 0 ? void 0 : item.audioUrl,
            isSlider: true
        })));
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, !props.isSkeletonVisible && /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'lg',
            fontWeight: 'normal',
            color: 'text.primary'
        }
    }, t("No data found")))), /*#__PURE__*/ React.createElement(React.Fragment, null, props.isSkeletonVisible && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '50px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    }))));
}
